import React from 'react';
import ReactDOM from 'react-dom/client';
import './media/css/fonts.css';
import './root.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

